<div ngClass.gt-sm="app-container-desktop" ngClass.lt-md="app-container-mobile" fxLayout="column" fxFill>
    <zui-sidenav
        #sidenav
        [sidenavParams]="sidenavConfig"
        [header]="sidenavHeader"
        (emitSelectedCompany)="selectCompany($event)"
        [hideSidenav]="hideSidenav$ | async"
    >
        <zui-progress-spinner
                id="app-loading"
                *ngIf="isLoading$ | async"
                class="app-root-progress-spinner"
                color="accent"
                diameter=256
        >
        </zui-progress-spinner>
        <router-outlet></router-outlet>
    </zui-sidenav>
    <div class="footer-content">
        <zui-footer-component></zui-footer-component>
    </div>
</div>
